export default "__VITE_ASSET__DLPBLj8u__"